export default {
    centerLocation: { lat: 29.3420477, lng: 47.9944882 },
    zoom: 12,
    selectedZoom:16
  };